import cx from 'classnames'
import { FC } from 'react'

import CustomAccordion from 'src/components/ui/atoms/CustomAccordion'
import { CustomAccordionProps } from 'src/components/ui/atoms/CustomAccordion/CustomAccordion'
import useTracking from 'src/hooks/useTracking'
import { WizardDataStatusInterface } from 'src/types/WizardDataStatusInterface'
import { WIZARD_STATUS } from 'src/utils/constant'
import WizardStatusContentItemHeader from './WizardStatusContentItemHeader'
import WizardStatusContentItems from './WizardStatusContentItems'

import * as styles from './WizardStatusContent.scss'

export interface StatusProps {
  dashboards: WizardDataStatusInterface[]
}

const WizardStatusContent: FC<StatusProps> = ({ dashboards }) => {
  const { trackEvent } = useTracking()
  const items: CustomAccordionProps['items'] = dashboards.map((dashboard, index) => ({
    label: <WizardStatusContentItemHeader dashboard={dashboard} />,
    content: <WizardStatusContentItems dashboard={dashboard} />,
    containerHeaderClassName: cx({
      [styles.StatusInMaintenance]: dashboard.type === WIZARD_STATUS.in_maintenance,
      [styles.ContainerHeaderFirstItem]: index === 0,
    }),
    contentClassName: cx({
      [styles.StatusInMaintenance]: dashboard.type === WIZARD_STATUS.in_maintenance,
    }),
    disabled:
      dashboard.type === WIZARD_STATUS.success && !Object.keys(dashboard.zero_revenue).length,
    onOpen: (isOpen: boolean) => {
      if (isOpen) {
        trackEvent({
          action: 'Check Data availability',
          label: dashboard.label,
        })
      }
    },
  }))

  return (
    <div data-testid="wizard-status-content" className={styles.Status}>
      <CustomAccordion items={items} />
    </div>
  )
}

export default WizardStatusContent
